import { Avatar, Spin } from 'antd';
import Box from 'components/Box';
import Button from 'components/Button';
import Text from 'components/Text';
import userApis from 'features/user/services/apis';
import { IStaffTicketResItem } from 'features/user/services/types/ticket';
import { useState } from 'react';
import { IResponseDataBody } from 'services/response';
import styled from 'styled-components';
import toast from 'utils/toast';

const StaffItemCallAction = ({ billId, staff }: { billId: string; staff: IStaffTicketResItem }) => {
    const [loading, setLoading] = useState(false);
    const [isCallTipSuccess, setIsCallTipSuccess] = useState(false);
    const [isCallTurnSuccess, setIsCallTurnSuccess] = useState(false);

    const handleCallTip = async () => {
        setLoading(true);
        try {
            const res: IResponseDataBody<boolean> = await userApis.voiceReminderTip(staff.staffId);
            if (res?.data?.data) {
                setIsCallTipSuccess(true);
                toast.success('Call tip successful');
            } else {
                toast.error('Call tip failed');
            }
        } catch (error) {
            toast.error('Call tip failed');
        } finally {
            setLoading(false);
        }
    };


    const handleCallTurn = async () => {
        setLoading(true);
        try {
            const res: IResponseDataBody<boolean> = await userApis.voiceNextTurn(billId, staff.staffId);
            if (res?.data?.data) {
                setIsCallTurnSuccess(true);
                toast.success('Call turn successful');
            } else {
                toast.error('Call turn failed');
            }
        } catch (error) {
            toast.error('Call turn failed');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Spin spinning={loading}>
            <StaffItem>
                <Box display='flex' alignItems='center' justifyContent='center'>
                    <Avatar src={staff.avatar} size={160}>
                        {staff.staffName?.[0] || 'A'}
                    </Avatar>
                </Box>
                <Text variant='H2'>{staff.staffName}</Text>
                <Box display='flex' alignItems='start' gap='3' justifyContent='space-between' alignSelf='stretch'>
                    <Button ntype='DARK_BLUE' cardCashier onClick={handleCallTip} disabled={isCallTipSuccess} style={{ width: '100%' }}>Call Tip</Button>
                    <Button ntype='PRIMARY' cardCashier onClick={handleCallTurn} disabled={isCallTurnSuccess} style={{ width: '100%' }}>Call Turn</Button>
                </Box>
            </StaffItem>
        </Spin>
    );
};

export default StaffItemCallAction;



const StaffItem = styled.div`
    display: flex;
    padding: 24px;
    flex-direction: column;
    align-items: center;
    gap: 15px;
    border-radius: 8px;
    border: 1px solid #D6D6E7;
    box-shadow: 0 2px 4px 0 rgba(44, 35, 66, 0.40);
    font-family: Poppins;
    
    .CONTENT_2 {
        font-family: Poppins;
        font-size: 20px;
    }
`;